export interface setTransactionSideProps {
  transaction: Transaction;
  transactionItems: TransactionItem[];
}
export default function setTransactionSide(props: setTransactionSideProps) {
  const transaction = props.transaction;
  const items: TransactionItem[] = props.transactionItems.map((item) => {
    const key = item.optionableType === "financial" ? item.optionType.type : item.optionableType ?? "account";
    let side = ["account", "person"].includes(key) && item?.amount > 0 ? "source" : "destination";
    if (transaction.type === "payment" && key === "person" && item.amount > 0) side = "destination";
    if (transaction.type === "payment" && key === "person" && item.amount < 0) side = "source";
    if (transaction.type === "income" && item.amount < 0) side = "destination";
    if (transaction.type === "income" && key === "account") side = "source";
    if (transaction.type === "cost" && key === "person" && item.amount > 0) side = "destination";
    if (transaction.type === "cost" && key === "account") side = "source";
    return { ...item, side };
  });
  if (transaction.Factors) {
    transaction.Factors.forEach(f => {
      const s: TransactionItem = {
        amount: f.Factor_Transaction.amount,
        optionableType: "person",
        optionableId: f.PersonId,
        optionType: f.Person,
        side: "source",
        factorId: f.id
      };
      items.push(s);
    })
  }
  return items;
}
